// Creative Crispies new design: content pages. Everything here is an enhancement; the pages work without it.
(() => {
if (window.__ccPages) return; window.__ccPages = true;
const $ = (s, r = document) => r.querySelector(s);
const root = (window.CC && CC.routes && CC.routes.root) || '/';
const url = p => root.replace(/\/$/, '') + p;

// contact: ?topic=wholesale (or any option text) preselects the topic
const topic = $('#cc-contact-topic');
if (topic) {
  const want = (new URLSearchParams(location.search).get('topic') || '').toLowerCase();
  if (want) [...topic.options].forEach(o => { if (o.value.toLowerCase().includes(want)) topic.value = o.value; });
}

// cart page: -/+/remove update in the background and re-render the section; the note saves as you type
const setCount = n => document.querySelectorAll('.cart i').forEach(i => { i.textContent = n; });
let noteTimer = null;
const saveNote = () => {
  const note = $('#cc-cart-note');
  if (!note) return Promise.resolve();
  clearTimeout(noteTimer);
  return fetch(url('/cart/update.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
};
document.addEventListener('input', e => {
  if (e.target.id !== 'cc-cart-note') return;
  clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600);
});

document.addEventListener('click', async e => {
  const a = e.target.closest('#cc-cart [data-ccp-key]');
  if (!a) return;
  const sec = $('#cc-cart');
  if (!sec || sec.classList.contains('busy')) { e.preventDefault(); return; }
  e.preventDefault();
  sec.classList.add('busy');
  const err = $('#cc-cart-err');
  try {
    await saveNote();
    const id = sec.dataset.section;
    const r = await fetch(url('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: a.dataset.ccpKey, quantity: +a.dataset.ccpQty, sections: [id], sections_url: location.pathname })
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) {
      if (err) { err.textContent = data.description || data.message || 'Could not update your cart. Please try again.'; err.hidden = false; }
      sec.classList.remove('busy');
      return;
    }
    const html = data.sections && data.sections[id];
    const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('#cc-cart');
    if (!fresh) { location.reload(); return; }
    // keep anything an app injected into the cart form (e.g. the gift option) instead of losing it on re-render
    const oldForm = $('#cc-cart-form', sec), newForm = $('#cc-cart-form', fresh);
    if (oldForm && newForm) [...oldForm.children].filter(c => !c.matches('.ccp-lines,.ccp-sum')).forEach(c => newForm.insertBefore(c, $('.ccp-sum', newForm)));
    sec.replaceWith(fresh);
    if (typeof data.item_count === 'number') setCount(data.item_count);
    document.dispatchEvent(new CustomEvent('cc:cart-updated', { detail: data }));
  } catch (_) {
    location.href = a.href; // fall back to the plain /cart/change link
  }
});
})();
